import { defineComponent as _defineComponent } from 'vue';
import { curveCatmullRom, curveLinear, line } from "d3";
import { computed } from "vue";
import { useWorkflowStores } from "@/composables/workflowStores";
import { vecSubtract } from "../modules/geometry";
import { colors } from "./colors";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FreehandComment',
    props: {
        comment: null
    },
    emits: ["remove"],
    setup(__props, { emit }) {
        const props = __props;
        const linear = line().curve(curveLinear);
        const catmullRom = line().curve(curveCatmullRom);
        const { commentStore, toolbarStore } = useWorkflowStores();
        const curve = computed(() => {
            if (commentStore.isJustCreated(props.comment.id)) {
                return linear(props.comment.data.line.map((p) => vecSubtract(p, props.comment.position))) ?? undefined;
            }
            else {
                return catmullRom(props.comment.data.line) ?? undefined;
            }
        });
        const style = computed(() => {
            const style = {
                "pointer-events": toolbarStore.currentTool === "freehandEraser" ? "stroke" : "none",
                "--thickness": `${props.comment.data.thickness}px`,
            };
            if (props.comment.color !== "none") {
                style["--color"] = colors[props.comment.color];
            }
            if (toolbarStore.inputCatcherEnabled) {
                style["cursor"] = "crosshair";
            }
            return style;
        });
        function onMouseOver() {
            if (toolbarStore.inputCatcherPressed) {
                emit("remove");
            }
        }
        function onClick() {
            if (toolbarStore.inputCatcherEnabled) {
                emit("remove");
            }
        }
        return { __sfc: true, props, emit, linear, catmullRom, commentStore, toolbarStore, curve, style, onMouseOver, onClick };
    }
});
